

export const stoteRowDetail = (state) => dispatch => {
    dispatch({ type: "ROW_STATE", payload: state })
}



// WEBPACK FOOTER //
// ./src/actions/storerowdetail.jsx